import { NgModule } from '@angular/core'
import { DepartmentService } from './department.service'

@NgModule({
  providers: [DepartmentService],
})
export class DepartmentsServiceModule {}
